class AppConfig {
	public readonly reasoningMode: boolean
	public readonly secretModeAccess: boolean
	public readonly apiUrl: string
	public readonly authRedirectUrl: string
	public readonly logoutUrl: string
	public readonly tokenCookieName: string
	public readonly modelName: string
	public readonly modelNameReasoning: string
	public readonly modelNameImgGenerator: string
	public readonly yaMetrikaId: string
	public readonly maxAudioRequestDuration: number
	public readonly maxAudioSilenceDuration: number
	public readonly maxSizeMB: number
	public readonly maxMessageLength: number
	public readonly local: string
	public readonly devSetting: boolean
	public readonly authMode: 'external' | 'internal'
	public readonly appVersion: 'b2c' | 'b2b'
	public readonly internalB2C: boolean
	public readonly musicMock: boolean
	public readonly tenant: string
	public readonly isMts: boolean
	public readonly colorPallate: string
	public readonly pwaEnabled: boolean
	public readonly pwaName: string
	public readonly pwaShortName: string
	public readonly pwaThemeColor: string
	public readonly pwaIconDir: string
	public readonly pwaAppleIcon: string
	public readonly pwaFavicon: string
	public readonly devAuthToken: string

	constructor() {
		this.reasoningMode = true
		this.secretModeAccess = true
		this.apiUrl = import.meta.env.VITE_API_URL
		this.authRedirectUrl = import.meta.env.VITE_AUTH_REDIRECT
		this.logoutUrl = import.meta.env.VITE_LOGOUT
		this.tokenCookieName = import.meta.env.VITE_TOKEN_COOKIE_NAME
		this.modelName = import.meta.env.VITE_MODEL_NAME
		this.yaMetrikaId = import.meta.env.VITE_YA_METRIKA_ID
		this.modelNameReasoning = import.meta.env.VITE_MODEL_NAME_REASONING || 'deepseek-v4-flash'
		this.modelNameImgGenerator = import.meta.env.VITE_MODEL_NAME_IMG || 'gpt-image-1'
		this.local = import.meta.env.VITE_LOCAL || 'RU'
		this.maxAudioRequestDuration = 30000
		this.maxAudioSilenceDuration = 5000
		this.maxSizeMB = 10
		this.maxMessageLength = 1000
		this.devSetting = import.meta.env.VITE_DEV_SETTTING || false
		this.authMode = import.meta.env.VITE_AUTH_MODE === 'internal' ? 'internal' : 'external'
		// Дефолт b2b: потребительские фичи (лимиты, оплата) включаются только явным b2c
		this.appVersion = import.meta.env.VITE_APP_VERSION === 'b2c' ? 'b2c' : 'b2b'
		// Розничная редакция со своим входом: страница /login (email + OTP), лимиты, онбординг.
		// В external вход живёт на внешнем auth-сервисе, в b2b розничных фич нет вовсе.
		this.internalB2C = this.authMode === 'internal' && this.appVersion === 'b2c'
		this.musicMock = import.meta.env.VITE_MUSIC_MOCK || false
		this.tenant = import.meta.env.VITE_TENANT || 'pomogai'
		this.isMts = this.tenant === 'MTSBY' || this.tenant === 'MTSPRO'
		this.colorPallate = import.meta.env.VITE_COLOR_PALLATE || 'default'
		this.pwaEnabled = import.meta.env.VITE_PWA_ENABLED !== 'false'
		this.pwaIconDir = import.meta.env.VITE_PWA_ICON_DIR || 'pomogai'
		this.pwaName = import.meta.env.VITE_PWA_NAME || 'Pomogai'
		this.pwaShortName = import.meta.env.VITE_PWA_SHORT_NAME || 'Pomogai'
		this.pwaThemeColor = import.meta.env.VITE_PWA_THEME_COLOR || '#191C22'
		this.pwaAppleIcon = `/icons/${this.pwaIconDir}/apple-touch-icon-180.png`
		this.pwaFavicon = `/icons/${this.pwaIconDir}/favicon.png`
		this.devAuthToken = import.meta.env.VITE_DEV_AUTH_TOKEN || ''
	}
}
export default new AppConfig()
